<div class="assisted-order-container">
  <!-- Header -->
  <div class="ao-header">
    <img src="assets/befret_logo.png" alt="BeFret" class="ao-logo">
    <h1>{{ 'ASSISTED_ORDER.TITLE' | translate }}</h1>
    <p class="ao-subtitle">{{ 'ASSISTED_ORDER.SUBTITLE' | translate }}</p>
  </div>

  <!-- STEP 1: Enter Code -->
  <div class="ao-card" *ngIf="currentStep === 'enter_code'">
    <div class="ao-card-header">
      <span class="ao-icon">🔑</span>
      <h2>{{ 'ASSISTED_ORDER.ENTER_CODE_TITLE' | translate }}</h2>
    </div>

    <p class="ao-instruction">{{ 'ASSISTED_ORDER.ENTER_CODE_INSTRUCTION' | translate }}</p>

    <!-- Code Input -->
    <div class="ao-code-input-container">
      <div class="ao-code-prefix">BEF-</div>
      <div class="ao-code-digits">
        <input
          *ngFor="let digit of codeDigits; let i = index"
          [id]="'code-' + i"
          type="text"
          maxlength="8"
          [value]="digit"
          (input)="onCodeInput(i, $event)"
          (keydown)="onCodeKeydown(i, $event)"
          class="ao-code-digit"
          [class.has-value]="digit"
          autocomplete="off"
          inputmode="text"
        >
      </div>
    </div>

    <!-- Error Message -->
    <div class="ao-error" *ngIf="errorMessage">
      <span class="ao-error-icon">⚠️</span>
      {{ errorMessage }}
    </div>

    <!-- Submit Button -->
    <button
      class="ao-btn ao-btn-primary"
      [disabled]="!isCodeComplete || isLoading"
      (click)="onSubmitCode()"
    >
      <span *ngIf="!isLoading">{{ 'ASSISTED_ORDER.VIEW_ORDER' | translate }}</span>
      <span *ngIf="isLoading" class="ao-spinner"></span>
    </button>

    <!-- Help -->
    <div class="ao-help">
      <p>{{ 'ASSISTED_ORDER.NO_CODE_QUESTION' | translate }}</p>
      <a href="javascript:void(0)" (click)="onContactSupport()">
        {{ 'ASSISTED_ORDER.CONTACT_US' | translate }}
      </a>
    </div>
  </div>

  <!-- STEP 2: Loading -->
  <div class="ao-card ao-loading-card" *ngIf="currentStep === 'loading'">
    <div class="ao-loading-spinner"></div>
    <p>{{ 'ASSISTED_ORDER.LOADING' | translate }}</p>
  </div>

  <!-- STEP 3: Show Summary -->
  <div class="ao-card ao-summary-card" *ngIf="currentStep === 'show_summary' && shipment">
    <div class="ao-card-header ao-success-header">
      <span class="ao-icon">✅</span>
      <h2>{{ 'ASSISTED_ORDER.ORDER_FOUND' | translate }}</h2>
    </div>

    <!-- Payment Cancelled Warning -->
    <div class="ao-cancelled-warning" *ngIf="paymentCancelled">
      <span>⚠️ {{ 'ASSISTED_ORDER.PAYMENT_CANCELLED' | translate }}</span>
    </div>

    <!-- Expiration Warning -->
    <div class="ao-expiration-warning">
      <span class="ao-clock-icon">⏱️</span>
      <span>{{ 'ASSISTED_ORDER.EXPIRES_IN' | translate }}: <strong>{{ expirationCountdown }}</strong></span>
    </div>

    <!-- Order Summary -->
    <div class="ao-summary">
      <!-- Tracking Number -->
      <div class="ao-summary-row ao-tracking-row">
        <span class="ao-label">{{ 'ASSISTED_ORDER.TRACKING_NUMBER' | translate }}</span>
        <span class="ao-value ao-tracking-number">{{ shipment.trackingNumber }}</span>
      </div>

      <!-- Sender -->
      <div class="ao-summary-section">
        <h3><span class="section-icon">📦</span> {{ 'ASSISTED_ORDER.SENDER' | translate }}</h3>
        <div class="ao-summary-row">
          <span class="ao-label">{{ 'ASSISTED_ORDER.NAME' | translate }}</span>
          <span class="ao-value">{{ shipment.sender.name }}</span>
        </div>
        <div class="ao-summary-row" *ngIf="shipment.sender.city">
          <span class="ao-label">{{ 'ASSISTED_ORDER.CITY' | translate }}</span>
          <span class="ao-value">{{ shipment.sender.city }}, {{ shipment.sender.country }}</span>
        </div>
      </div>

      <!-- Receiver -->
      <div class="ao-summary-section">
        <h3><span class="section-icon">📍</span> {{ 'ASSISTED_ORDER.RECEIVER' | translate }}</h3>
        <div class="ao-summary-row">
          <span class="ao-label">{{ 'ASSISTED_ORDER.NAME' | translate }}</span>
          <span class="ao-value">{{ shipment.receiver.name }}</span>
        </div>
        <div class="ao-summary-row">
          <span class="ao-label">{{ 'ASSISTED_ORDER.CITY' | translate }}</span>
          <span class="ao-value">{{ shipment.receiver.city }}</span>
        </div>
      </div>

      <!-- Parcel -->
      <div class="ao-summary-section">
        <h3><span class="section-icon">📏</span> {{ 'ASSISTED_ORDER.PARCEL' | translate }}</h3>
        <div class="ao-summary-row">
          <span class="ao-label">{{ 'ASSISTED_ORDER.WEIGHT' | translate }}</span>
          <span class="ao-value">{{ shipment.parcel.weight }} kg</span>
        </div>
        <div class="ao-summary-row" *ngIf="shipment.parcel.description">
          <span class="ao-label">{{ 'ASSISTED_ORDER.CONTENT' | translate }}</span>
          <span class="ao-value">{{ shipment.parcel.description }}</span>
        </div>
      </div>

      <!-- Service -->
      <div class="ao-summary-section">
        <h3><span class="section-icon">🚚</span> {{ 'ASSISTED_ORDER.SERVICE' | translate }}</h3>
        <div class="ao-summary-row">
          <span class="ao-label">{{ 'ASSISTED_ORDER.SERVICE_TYPE' | translate }}</span>
          <span class="ao-value">{{ getServiceTypeLabel() }}</span>
        </div>
        <div class="ao-summary-row" *ngIf="shipment.service.pickupPoint">
          <span class="ao-label">{{ 'ASSISTED_ORDER.PICKUP_POINT' | translate }}</span>
          <span class="ao-value">{{ shipment.service.pickupPoint.name }}</span>
        </div>
        <div class="ao-options" *ngIf="shipment.service.fragile || shipment.service.emballage">
          <span class="ao-option" *ngIf="shipment.service.fragile">🥚 {{ 'ASSISTED_ORDER.FRAGILE' | translate }}</span>
          <span class="ao-option" *ngIf="shipment.service.emballage">📦 {{ 'ASSISTED_ORDER.PACKAGING' | translate }}</span>
        </div>
      </div>

      <!-- Price -->
      <div class="ao-price-section">
        <div class="ao-price-row">
          <span class="ao-price-label">{{ 'ASSISTED_ORDER.TOTAL_TO_PAY' | translate }}</span>
          <span class="ao-price-value">{{ formatPrice(shipment.pricing.total, shipment.pricing.currency) }}</span>
        </div>
      </div>
    </div>

    <!-- Pay / Retry Button -->
    <button
      class="ao-btn ao-btn-pay"
      [disabled]="isProcessingPayment"
      (click)="paymentCancelled ? onRetryPayment() : onPay()"
    >
      <span *ngIf="!isProcessingPayment && !paymentCancelled">
        💳 {{ 'ASSISTED_ORDER.PAY_NOW' | translate }} - {{ formatPrice(shipment.pricing.total, shipment.pricing.currency) }}
      </span>
      <span *ngIf="!isProcessingPayment && paymentCancelled">
        🔄 {{ 'ASSISTED_ORDER.RETRY_PAYMENT' | translate }} - {{ formatPrice(shipment.pricing.total, shipment.pricing.currency) }}
      </span>
      <span *ngIf="isProcessingPayment" class="ao-spinner"></span>
    </button>

    <!-- Error Message -->
    <div class="ao-error" *ngIf="errorMessage">
      <span class="ao-error-icon">⚠️</span>
      {{ errorMessage }}
    </div>

    <!-- Other Code Link -->
    <div class="ao-other-code">
      <a href="javascript:void(0)" (click)="onRetry()">
        {{ 'ASSISTED_ORDER.USE_OTHER_CODE' | translate }}
      </a>
    </div>
  </div>

  <!-- STEP: Payment Success -->
  <div class="ao-card ao-success-card" *ngIf="currentStep === 'payment_success'">
    <div class="ao-card-header ao-success-header">
      <span class="ao-icon">🎉</span>
      <h2>{{ 'ASSISTED_ORDER.PAYMENT_SUCCESS_TITLE' | translate }}</h2>
    </div>

    <p class="ao-success-message">{{ 'ASSISTED_ORDER.PAYMENT_SUCCESS_MESSAGE' | translate }}</p>

    <div class="ao-success-tracking" *ngIf="codeDigits.join('')">
      <span class="ao-label">{{ 'ASSISTED_ORDER.YOUR_CODE' | translate }}</span>
      <span class="ao-value ao-tracking-number">BEF-{{ codeDigits.join('') }}</span>
    </div>

    <div class="ao-success-next-steps">
      <p>{{ 'ASSISTED_ORDER.PAYMENT_SUCCESS_NEXT' | translate }}</p>
    </div>

    <button class="ao-btn ao-btn-primary" (click)="onContactSupport()">
      {{ 'ASSISTED_ORDER.CONTACT_SUPPORT' | translate }}
    </button>
  </div>

  <!-- STEP 4: Error -->
  <div class="ao-card ao-error-card" *ngIf="currentStep === 'error'">
    <div class="ao-card-header ao-error-header">
      <span class="ao-icon">❌</span>
      <h2>{{ 'ASSISTED_ORDER.ERROR_TITLE' | translate }}</h2>
    </div>

    <div class="ao-error-content">
      <p class="ao-error-message">{{ errorMessage }}</p>

      <!-- Specific error guidance -->
      <div class="ao-error-guidance" *ngIf="errorCode === 'expired'">
        <p>{{ 'ASSISTED_ORDER.EXPIRED_GUIDANCE' | translate }}</p>
      </div>

      <div class="ao-error-guidance" *ngIf="errorCode === 'already-paid'">
        <p>{{ 'ASSISTED_ORDER.ALREADY_PAID_GUIDANCE' | translate }}</p>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="ao-error-actions">
      <button class="ao-btn ao-btn-secondary" (click)="onRetry()">
        {{ 'ASSISTED_ORDER.TRY_AGAIN' | translate }}
      </button>
      <button class="ao-btn ao-btn-primary" (click)="onContactSupport()">
        {{ 'ASSISTED_ORDER.CONTACT_SUPPORT' | translate }}
      </button>
    </div>
  </div>

  <!-- Footer -->
  <div class="ao-footer">
    <p>{{ 'ASSISTED_ORDER.SECURE_PAYMENT' | translate }}</p>
    <div class="ao-payment-icons">
      <span class="payment-badge payment-cb">CB</span>
      <span class="payment-badge payment-paypal">PayPal</span>
      <span class="payment-badge payment-klarna">Klarna</span>
      <span class="payment-badge payment-bancontact">Bancontact</span>
    </div>
    <p class="ao-contact">
      {{ 'ASSISTED_ORDER.NEED_HELP' | translate }}
      <a [href]="'tel:' + supportPhoneTel">{{ supportPhone }}</a> |
      <a href="https://api.whatsapp.com/send/?phone=32473282139&text&type=phone_number&app_absent=0" target="_blank">WhatsApp</a>
    </p>
  </div>
</div>
